'use client'
import 'react-country-phone-input/lib/style.css'
import { clsx } from 'clsx'

import { CSSProperties, FC } from 'react'
import PhoneInput from 'react-country-phone-input'
import { Controller, useFormContext } from 'react-hook-form'

import { priorityCountry, uaLang } from '@/app/shared/components/select-phone/constants'
import useTailwindColor from '@/app/shared/hooks/useTailwindColor'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import { required } from '@/app/shared/validation'
import { languageTag } from '@/core/lib/locale/i18n'

import styles from './style.module.scss'

// interface
interface ISelectPhone extends IClassName {
  name: string
  isRequired?: boolean
  colorType?: string
}

// component
const SelectPhoneComponent: FC<Readonly<ISelectPhone>> = ({
  className,
  name,
  colorType,
  isRequired,
}) => {
  const { control } = useFormContext()
  const { getColor } = useTailwindColor()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={undefined}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <div
          className={clsx(className, styles.selectPhone)}
          style={
            {
              '--color': colorType ?? getColor('text-secondary'),
            } as CSSProperties
          }
        >
          <PhoneInput
            country={'ua'}
            localization={uaLang}
            preferredCountries={priorityCountry}
            preserveOrder={['onlyCountries', 'preferredCountries']}
            excludeCountries={['ru', 'by']}
            value={value}
            onChange={onChange}
            enableSearch
            containerClass={clsx(styles.selectPhone__content)}
            inputClass={clsx({
              'text-danger': !!error?.message,
            })}
            searchPlaceholder={'Пошук країни'}
            searchNotFound={'Країни не знайдено'}
            inputProps={{
              name: 'phone',
              required: isRequired,
            }}
          />
          {error?.message && (
            <div className='relative flex flex-col gap-1.5 p-1'>
              <div className='text-tiny text-warning'>{error?.message}</div>
            </div>
          )}
        </div>
      )}
      rules={{
        required: required(languageTag()),
      }}
    />
  )
}

export default SelectPhoneComponent
